const config = {
    apiKey: "AIzaSyCjeitkVYo49NxN5PQue7sk50lSukat4do",
    authDomain: "portfolio-v7.firebaseapp.com",
    databaseURL: "https://portfolio-v7.firebaseio.com",
    projectId: "portfolio-v7",
    storageBucket: "portfolio-v7.appspot.com",
    messagingSenderId: "33055843059"
};

export default config;


// WEBPACK FOOTER //
// ./src/firebase.config.js